import React, { FC } from 'react';
import { LandscapeNotSavedInfoTemplate } from '../../templates';

interface LandscapeNotSavedInfoPageProps {
  content: string;
}

const LandscapeNotSavedInfoPage: FC<LandscapeNotSavedInfoPageProps> = ({
  content,
}) => {
  return <LandscapeNotSavedInfoTemplate content={content} />;
};

export default LandscapeNotSavedInfoPage;
